// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__33gL-","inner":"Footer_inner__3avVa"};